import React from 'react';
import { 
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Typography,
  ListItemIcon
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import VisibilityIcon from '@mui/icons-material/Visibility';

const drawerWidth = 240;

const Navigation: React.FC = () => {
  const location = useLocation();

  const menuItems = [
    { label: 'Family valuation mock up', path: '/version1', icon: AccountBalanceWalletIcon },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          position: 'fixed',
          height: '100vh',
          background: 'linear-gradient(180deg, #8e24aa 0%, #6a1b9a 50%, #4a148c 100%)',
          borderRight: 'none',
        },
      }}
    >
      <Box sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <VisibilityIcon sx={{ color: 'white', fontSize: '2rem' }} />
        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', color: 'white', letterSpacing: '0.1em' }}>
          HEIRWEALTH
        </Typography>
      </Box>
      
      <List sx={{ pt: 2, px: 1 }}>
        {menuItems.map((item) => (
          <ListItem key={item.path} disablePadding sx={{ mb: 0.5 }}>
            <ListItemButton
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              sx={{
                borderRadius: 1,
                color: 'white',
                py: 1.5,
                px: 2,
                '&.Mui-selected': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  },
                },
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 40, color: 'white' }}>
                <item.icon />
              </ListItemIcon>
              <ListItemText 
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: '0.95rem',
                  fontWeight: location.pathname === item.path ? '600' : '400'
                }}
              />
              {item.label === 'Family valuation mock up' && (
                <Box sx={{ color: 'white', opacity: 0.7 }}>
                  ›
                </Box>
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      
      {/* Footer */}
      <Box sx={{ 
        mt: 'auto', 
        p: 2, 
        textAlign: 'center',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
          Powered by
        </Typography>
        <Typography variant="body2" sx={{ color: 'white', fontWeight: 'bold', mt: 0.5 }}>
          HeirWealth
        </Typography>
      </Box>
    </Drawer>
  );
};

export default Navigation;
